import { CoreIconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@b2bportal/core-ui";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { ApacUiComponent } from "../../context";
import { useApacUiStyles } from "../../hooks";
import defaultStyles from "./styles.module.scss";

export const BestPriceGuaranteeModalContent = () => {
  const styles = useApacUiStyles(
    ApacUiComponent.BestPriceGuaranteeModalContent,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    ApacUiComponent.BestPriceGuaranteeModalContent
  );

  const {
    t,
    brand: {
      urls: { helpCenterBaseUrl },
    },
  } = useI18nContext();

  return (
    <div className={clsx(block)}>
      <div className={cn("best-price-guarantee-subtitle")}>
        {t("apac.bestPriceGuarantee.subtitle")}
      </div>
      <div className={cn("best-price-guarantee-description")}>
        <Icon iconName={CoreIconNameEnum.checkFilled} />
        {t("apac.bestPriceGuarantee.lowerPriceDescription")}
      </div>
      <div className={cn("best-price-guarantee-description")}>
        <Icon iconName={CoreIconNameEnum.checkFilled} />
        {t("apac.bestPriceGuarantee.rateComparisonDescription")}
      </div>

      <div className={cn("best-price-guarantee-description")}>
        <Icon iconName={CoreIconNameEnum.checkFilled} />
        <span>
          <Trans
            i18nKey="apac.bestPriceGuarantee.customerSupportDescription"
            components={[
              // We have to disable this rule because jsx-a11y interprets this
              // i18next component template as an empty anchor tag.

              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a href={helpCenterBaseUrl} />,
            ]}
          />
        </span>
      </div>
      <ul className={cn("best-price-guarantee-bullet-list")}>
        <li className={cn("best-price-guarantee-bullet")}>
          {t("apac.bestPriceGuarantee.bookingConfirmationCode")}
        </li>
        <li className={cn("best-price-guarantee-bullet")}>
          {t("apac.bestPriceGuarantee.bookingType")}
        </li>
        <li className={cn("best-price-guarantee-bullet")}>
          {t("apac.bestPriceGuarantee.travelDates")}
        </li>
        <li className={cn("best-price-guarantee-bullet")}>
          {t("apac.bestPriceGuarantee.pricePaidDifference")}
        </li>
        <li className={cn("best-price-guarantee-bullet")}>
          {t("apac.bestPriceGuarantee.numberOfTravelers")}
        </li>
        <li className={cn("best-price-guarantee-bullet")}>
          {t("apac.bestPriceGuarantee.screenshot")}
        </li>
      </ul>
      <div className={cn("best-price-guarantee-description")}>
        <Icon iconName={CoreIconNameEnum.checkFilled} />
        {t("apac.bestPriceGuarantee.flightConfirmation")}
      </div>
      <div className={cn("best-price-guarantee-description")}>
        <Icon iconName={CoreIconNameEnum.checkFilled} />
        <span>
          <Trans
            i18nKey="apac.bestPriceGuarantee.otherQuestions"
            components={[
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a href="/faqs" target="_blank" rel="noopener noreferrer" />,
            ]}
          />
        </span>
      </div>
    </div>
  );
};
